/* tslint:disable */
/* eslint-disable */
/**
 * Brokers API
 * API for managing brokers
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Adresse enregistrée du cabinet (mêmes noms que l'adresse de la commande de mise à jour).
 * @export
 * @interface GetBrokerAddressDto
 */
export interface GetBrokerAddressDto {
    /**
     * 
     * @type {string}
     * @memberof GetBrokerAddressDto
     */
    line1?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrokerAddressDto
     */
    line2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetBrokerAddressDto
     */
    line3?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetBrokerAddressDto
     */
    zipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrokerAddressDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrokerAddressDto
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrokerAddressDto
     */
    formattedAddress?: string | null;
    /**
     * Null quand l'adresse enregistrée ne porte pas de lieu Google.
     * @type {string}
     * @memberof GetBrokerAddressDto
     */
    googlePlaceId?: string | null;
}

/**
 * Check if a given object implements the GetBrokerAddressDto interface.
 */
export function instanceOfGetBrokerAddressDto(value: object): value is GetBrokerAddressDto {
    return true;
}

export function GetBrokerAddressDtoFromJSON(json: any): GetBrokerAddressDto {
    return GetBrokerAddressDtoFromJSONTyped(json, false);
}

export function GetBrokerAddressDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBrokerAddressDto {
    if (json == null) {
        return json;
    }
    return {
        
        'line1': json['line1'] == null ? undefined : json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'line3': json['line3'] == null ? undefined : json['line3'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
        'formattedAddress': json['formattedAddress'] == null ? undefined : json['formattedAddress'],
        'googlePlaceId': json['googlePlaceId'] == null ? undefined : json['googlePlaceId'],
    };
}

export function GetBrokerAddressDtoToJSON(json: any): GetBrokerAddressDto {
    return GetBrokerAddressDtoToJSONTyped(json, false);
}

export function GetBrokerAddressDtoToJSONTyped(value?: GetBrokerAddressDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'line1': value['line1'],
        'line2': value['line2'],
        'line3': value['line3'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'country': value['country'],
        'formattedAddress': value['formattedAddress'],
        'googlePlaceId': value['googlePlaceId'],
    };
}

